import * as React from "react";

const MOBILE_BREAKPOINT = 768;

// Optional `breakpoint` param lets call sites opt into a wider "compact"
// threshold (e.g. the admin shell collapses to a mobile nav at ~1000px,
// wider than the shadcn Sidebar primitive's own 768px default) without
// forking this hook. Existing call sites that don't pass one keep 768px.
export function useIsMobile(breakpoint: number = MOBILE_BREAKPOINT) {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < breakpoint);
    return () => mql.removeEventListener("change", onChange);
  }, [breakpoint]);

  return !!isMobile;
}
